import './i18n';
import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ConnectedStore from './Shared/ConnectedStore';
import { UserReducer, initialState, Provider as UserProvider } from './Shared/UserContext';
import { HelmetProvider } from "react-helmet-async";
import {
  Provider as ProviderConfig,
  initialState as initConfig,
  ConfigReducer,
} from './Shared/ConfigContext';
import ProtectedRoute from './Shared/ProtectedRoute';
import Login from './components/Login';
import Products from './modules/Inventory/Products';
import Utilisateurs from './modules/Users/Utilisateurs';
import RapportEcarts from './modules/Inventory/RapportEcarts';
import RapportZones from './modules/Inventory/RapportZones';
import Zones from './modules/Inventory/Zones';
import Inventaires from './modules/Inventory/Inventaires';
import ZoneDetails from './modules/Inventory/ZoneDetails';
import Emplacements from './modules/Inventory/Emplacements';
import Depots from './modules/Inventory/Depots';
import MobileInterface from './components/MobileInterface';
import Dashboard from './modules/Inventory/Dashboard';
import RapportZonesDetails from './modules/Inventory/RapportZonesDetails';

import './index.css';
import './output.css';
const isMobile = () =>
  /(Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini)/i.test(navigator.userAgent);

const AppRoutes = () => {
  const onMobile = isMobile();

  if (onMobile) {
    return <MobileInterface />;
  }
  return (
    <Switch>
      <Route path="/login" component={Login} exact />
      {/* Grayfox inventory menu items */}
      <ProtectedRoute path="/dashboard" component={Dashboard} exact /> 
      <ProtectedRoute path="/rapport-ecarts" component={RapportEcarts} exact />
      <ProtectedRoute path="/rapport-zones/details/:id" component={RapportZonesDetails} exact />
      <ProtectedRoute path="/rapport-zones" component={RapportZones} exact />
      <ProtectedRoute path="/produits" component={Products} exact />
      <ProtectedRoute path="/inventaires" component={Inventaires} exact />
      <ProtectedRoute path="/zones/details/:id" component={ZoneDetails} exact />
      <ProtectedRoute path="/zones" component={Zones} exact />
      <ProtectedRoute path="/emplacements" component={Emplacements} exact />
      <ProtectedRoute path="/utilisateurs" component={Utilisateurs} exact />
      <ProtectedRoute path="/" component={Depots} exact />
    </Switch>
  );
};

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <div>
          <AppRoutes />
        </div>
      </Router>
    </HelmetProvider>
  );
};

const ConnectedToUserContext = ConnectedStore(App, UserReducer, initialState, UserProvider);
export default ConnectedStore(ConnectedToUserContext, ConfigReducer, initConfig, ProviderConfig);
